import { flatten, compact } from 'lodash'

// the navItem of the current path and any parents should be active
// provide currentPath as a navItem's path
function isActive(currentPath, navItem) {
  const navTreePaths = flatten(navTree(navItem).map((item) => item.path))
  return navTreePaths.includes(currentPath)
}

// returns an array of navItems for the rest of the navItem's tree
// (can start at any point in the tree)
function navTree(navItem) {
  const firstDescendents = compact(navItem.children)
  const secondDescendents = compact(secondDescendantNavItems(navItem))
  return flatten([navItem, firstDescendents, flatten(secondDescendents)])
}

function secondDescendantNavItems(navItem) {
  return (
    hasChildren(navItem) &&
    navItem.children.map((childNav) => childNav.children)
  )
}

function hasChildren(navItem) {
  return navItem.children && navItem.children.length > 0
}

// returns array of IDs for nav items in the ative nav tree
function activeNavTreeIds(currentPath, activeTopLevelNav, navItemGroups) {
  const currentNavItemGroup = navItemGroups.find(
    (navItemGroup) => navItemGroup.topLevelNav === activeTopLevelNav
  )
  if (!currentNavItemGroup) return []
  const navTrees = currentNavItemGroup.navItems.map((navItem) =>
    navTree(navItem)
  )
  const activeTree = navTrees.find((nt) => isActive(currentPath, nt))
  if (!activeTree) return []
  const activeNavs = activeTree.filter((at) => isActive(currentPath, at))
  return activeNavs.map((an) => an.id)
}

export default activeNavTreeIds
